import { type V3Theme, v3 } from './theme';

export type { V3Theme };
export { v3 };
